import {
    Badge,
    Box,
    Divider,
    HStack,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Spinner,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useDisclosure,
    useToast,
    VStack
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { getMessages } from "../../api";
import AccessDenied from "../../components/AccessDenied";
import TitleHeader from '../../components/TitleHeader';
import { hasPermission, trimText } from "../../Utils";
import SendMessageModal from "./SendMessageModal";
import SendPushNotification from "./SendPushNotification";


const MessagesList = () => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenPush, setIsModalOpenPush] = useState(false);
    const [msgContent, setMsgContent] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();


    const toast = useToast();

    useEffect(() => {
        fetchMessages();
    }, [page]);

    const fetchMessages = async () => {
        setLoading(true);
        try {
            const response = await getMessages(1, 500);

            if (response.success) {
                setMessages(response.data.messages);
            } else {
                setMessages([])
            }


        } catch (error) {
            toast({ title: "Error fetching messages", status: "error" });
        }
        setLoading(false);
    };

    if (!hasPermission('viewMessages')) {
        return (
            <AccessDenied msg={"You don't have permission to view this page"} />
        )
    }







    return (
        <Box>

            <TitleHeader
                title="Couriers Messaging"
                buttonText={"Send Message"}
                onClick={() => setIsModalOpen(true)}
            />


            {loading ? <Spinner size="xl" /> : (

                messages.length > 0 ?
                    <Table variant="simple">
                        <Thead>
                            <Tr>
                                <Th>Message</Th>
                                <Th>Courier</Th>
                                <Th>Sender</Th>
                                <Th>Status</Th>
                                <Th>Push Notification</Th>
                                <Th>Created At</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {messages.map((msg) => (
                                <Tr key={msg.id}>
                                    <Td cursor={'pointer'} onClick={() => {
                                        setMsgContent(msg)
                                        onOpen()
                                    }
                                    }>{trimText(msg.message, 20)}</Td>
                                    <Td>{msg.toAll ? "To All" : msg.courierId?.name || "N/A"}</Td>
                                    <Td>{msg.sender?.firstName || "N/A"}</Td>
                                    <Td>
                                        <Badge
                                            colorScheme={
                                                msg.toAll ? 'yellow' :
                                                    msg.status == 'unread'
                                                        ? "pink"
                                                        : 'green'
                                            }
                                        >
                                            {msg.toAll ? "N/A" : msg.status}
                                        </Badge>
                                    </Td>
                                    <Td>{msg?.push ? "Yes" : "No"}</Td>
                                    <Td>
                                        {new Date(msg.createdAt).toLocaleString()}
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                    :
                    <Box mt={10} justifyContent={'center'} alignContent={'ce'}>
                        <AccessDenied msg="No messages yet" />
                    </Box>
            )}


            <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside" size="xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Message Details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody p={7}>
                        <VStack align="start" spacing={4}>
                            <HStack w="100%" justify="space-between">
                                <Text fontWeight="bold">To:</Text>
                                <Text>{msgContent?.toAll ? "To All" : msgContent?.courierId?.name || "N/A"}</Text>
                            </HStack>

                            <HStack w="100%" justify="space-between">
                                <Text fontWeight="bold">Sender:</Text>
                                <Text>{msgContent?.sender?.firstName || "N/A"}</Text>
                            </HStack>

                            <HStack w="100%" justify="space-between">
                                <Text fontWeight="bold">Status:</Text>
                                <Badge
                                    colorScheme={
                                        msgContent?.toAll
                                            ? "yellow"
                                            : msgContent?.status === "unread"
                                                ? "pink"
                                                : "green"
                                    }
                                >
                                    {msgContent?.toAll ? "N/A" : msgContent?.status}
                                </Badge>
                            </HStack>

                            <HStack w="100%" justify="space-between">
                                <Text fontWeight="bold">Push Notification:</Text>
                                <Text>{msgContent?.push ? "Yes" : "No"}</Text>
                            </HStack>

                            <HStack w="100%" justify="space-between">
                                <Text fontWeight="bold">Created At:</Text>
                                <Text>{new Date(msgContent?.createdAt).toLocaleString()}</Text>
                            </HStack>

                            <Divider />

                            <Text fontWeight="bold">Message:</Text>
                            <Text>{msgContent?.message}</Text>

                            {msgContent?.images?.length > 0 && (
                                <VStack spacing={3} mt={4} w="100%">
                                    {msgContent.images.map((img, i) => (
                                        <Image
                                            key={i}
                                            src={`https://thelabsys.com/ups${img}`}
                                            alt={`Image ${i + 1}`}
                                            borderRadius="md"
                                            objectFit="cover"
                                            w="100%"
                                            maxH="300px"
                                        />
                                    ))}
                                </VStack>
                            )}
                        </VStack>
                    </ModalBody>
                </ModalContent>
            </Modal>


            <SendMessageModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
            <SendPushNotification isOpen={isModalOpenPush} onClose={() => setIsModalOpenPush(false)} />


        </Box>
    );
};

export default MessagesList;
